import { GetterTree } from 'vuex';
import { State } from '@/store/modules/log/logCommonState/log.store';
import {
  LM_CAPABILITY,
  ANALYTICS_CAPABILITY,
} from '@/components/Log/log.constants';

const getters: GetterTree<State, State> = {
  getWidgetSavedSearchInfo(state: State) {
    return state.addWidgetData.savedSearchInfo;
  },
  getWidgetAddDashboardInfo(state: State) {
    return state.addWidgetData.addDashboardInfo;
  },
  getWidgetFormData(state: State) {
    return state.addWidgetData.widgetFormData;
  },
  getExecuteSavedSearch(state: State) {
    return state.executeSavedSearch;
  },
  getCapabilityType(state: State) {
    return state.isADType ? ANALYTICS_CAPABILITY : LM_CAPABILITY;
  },
};

export default getters;
